<!-- src/components/Applications/BreytingSereign/Steps/Step3_Summary.vue -->
<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useUmsokn } from '@/composables/Applications/UseUmsokn'

// Reuse your substeps exactly as named
import Step1 from '../../Shared/Umsaekjandi.vue'
import Step2 from './Step2.vue'

const { t } = useI18n()
const { umsokn } = useUmsokn()

// Optional props to keep drop-in compatible with old shell
const props = defineProps<{
  disable?: boolean
  handlePrev?: () => void
  handleNext?: (v?: unknown) => void
}>()

// Open first panel by default
const expanded = ref<number[]>([0])

// Summary is read-only; let parent advance freely
defineExpose({
  async validate() { return true }
})
</script>

<template>
  <div v-if="umsokn" class="m-b-40">
    <v-col cols="12" xl="6" class="mx-auto">
      <!-- Header -->
      <v-row>
        <v-col>
          <h2 class="forms__header">
            {{ t('umsokn_samantekt_header') }}
          </h2>
        </v-col>
      </v-row>

      <!-- Intro -->
      <v-row>
        <v-col>
          <p>{{ t('umsokn_samantekt_header2') }}</p>
        </v-col>
      </v-row>

      <!-- Summary Expansion -->
      <v-row>
        <v-col class="application__summary">
          <v-expansion-panels v-model="expanded" multiple>
            <v-expansion-panel>
              <v-expansion-panel-title>
                {{ t('umsokn_samantekt_upplysingar') }}
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <div>
                  <Step1 :umsokn="umsokn" :disable="true" />
                </div>
                <div class="m-t-100">
                  <Step2 :umsokn="umsokn" :disable="true" />
                </div>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>

<style scoped lang="scss">
.m-t-100 { margin-top: 100px; }
.m-b-40 { margin-bottom: 40px; }
.forms__header {
  color: #194458;
  font-weight: 900;
  font-size: 28px;
  line-height: 1.25;
  margin: 0 0 12px;
}
</style>
